module.exports = __webpack_public_path__ + "img/btn_menu_lsjjr.4eabc964.png";